import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from '../../../components/Page';
import { Card, Container } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import EmployeeVisitsDelayCalculationReportTable from './EmployeeVisitsDelayCalculationReportTable';
import useAccess from '../../../hooks/useAccess';
import { AbilitySubjects } from '../../../casl/ability';
import EmployeeVisitsDelayCalculationReportTableHeader from './EmployeeVisitsDelayCalculationReportTableHeader';

export default function EmployeeVisitsDelayCalculationReportPage() {
  const { t } = useTranslation();
  useAccess('read', AbilitySubjects.ADMIN_ABILITY);

  return (
    <Page title={t('financialReports.visitsDelayCalculation.reportName')}>
      <Container>
        <PageHeader
          pageTitle={t('financialReports.visitsDelayCalculation.reportName')}
          pageFilter={<EmployeeVisitsDelayCalculationReportTableHeader />}
          smallScreenDirection="row"
        />
        <Card>
          <EmployeeVisitsDelayCalculationReportTable />
        </Card>
      </Container>
    </Page>
  );
}
